import {
  detailsEndpoint,
  productCategoryEndpoint,
  productsEndpoint,
  soldProductsEndpoint,
  topSellingGarmentEndpoint,
  topSellingGarmentPageEndpoint,
} from '../constants';
import { useAuthAxiosRequest } from './useAuthAxiosRequest';
import { useUser } from './useController';
import { LastUpdatedTime, StorePerformanceRequest } from './useTransaction';

export type SoldProductItem = {
  salesNetLastWeek: number;
  salesNetLastYear: number;
  productName: string;
  productId: string;
  price: number;
  soldPieces: number;
  departmentId: string;
  departmentName: string;
  departmentNumber: string;
  season: string;
  salesNet: number;
  mostSoldArticle: string;
  index: string;
  subIndex: string;
  // TODO: add after BE change
  // stockAvailable: boolean;
  // speed: number;
  // remainingPieces: number;
  // moneyGenerated: string;
  // category: string;
};

export type ProductDetails = {
  color: string[];
  size: string[];
};

export type ProductIndexItem = {
  id: string;
  customerGroup: string; //Business Unit(BU)
  divisionName: string;
  indexDescription: string; //Index
  subindex: string; //Sub Index
  departmentName: string;
  departmentNumber: string;
  garmentGroup: string;
  salesNet: number;
  salesNetLastWeek: number;
  salesNetLastYear: number;

  lastUpdated: string;
  productName: string;
  season: number;
  whitePrice: number;
  currency: string;
  sectionName: string;
  indexGroupName: string;
};

export type GarmentResponse = {
  category: string;
  title: string;
  articleIdentifier: string;
  productId: string;
  whitePrice?: number;
  currency?: string;
};

export type TopSellingGarmentItem = GarmentResponse & {
  soldPieces: number;
  moneyGenerated: number;
};

export type TopSellingResponse = LastUpdatedTime & {
  topSellingGarments: TopSellingGarmentItem[];
};

export const useSoldProducts = () => {
  const {
    get: { currentStoreId, keyToken },
  } = useUser();

  const { authAxiosRequest } = useAuthAxiosRequest(keyToken);

  const fetchSoldProducts = async (request: StorePerformanceRequest) => {
    const soldProductsResponse = await authAxiosRequest<SoldProductItem[]>(
      `${soldProductsEndpoint}/${currentStoreId}${topSellingGarmentPageEndpoint}`,
      {
        params: request,
      },
    );

    return soldProductsResponse;
  };

  const fetchSoldProductsDetails = async (productId: string, request: StorePerformanceRequest) => {
    const soldProductsDetailsResponse = await authAxiosRequest<ProductDetails>(
      `${soldProductsEndpoint}/${currentStoreId}${productsEndpoint}${productId}${detailsEndpoint}`,
      {
        params: request,
      },
    );

    return soldProductsDetailsResponse;
  };

  const fetchProductIndex = async (request: StorePerformanceRequest) => {
    const soldProductsResponse = await authAxiosRequest<ProductIndexItem[]>(
      `${soldProductsEndpoint}/${currentStoreId}${productCategoryEndpoint}`,
      {
        params: request,
      },
    );

    return soldProductsResponse;
  };

  const fetchTopSellingGarmentData = async (request: StorePerformanceRequest) => {
    const topSellingGarmentResponse = await authAxiosRequest<TopSellingResponse>(
      `${soldProductsEndpoint}/${currentStoreId}${topSellingGarmentEndpoint}`,
      {
        params: request,
      },
    );

    return topSellingGarmentResponse;
  };

  return {
    fetchSoldProducts,
    fetchSoldProductsDetails,
    fetchProductIndex,
    fetchTopSellingGarmentData,
  };
};
